import React from 'react';
import EvisNailArt from './EvisNailArt_Rozsa';

export default function App() {
  return <EvisNailArt />;
}
